module.exports = __webpack_public_path__ + "img/banner.b4da2e04.jpg";